import React, { ChangeEvent, Component, useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, FloatingLabel, Form, FormControl, Row } from 'react-bootstrap'
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext';
import { GetUserByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Users/models/userModels';
import { updateUserInfo } from '../../../../Adaptor/TUBSIS';

type Props = {userData: GetUserByIdOutput | null}

const PatientUserInfo : React.FC<Props> = ({ userData }) => {

    const [activeAccordion, setActiveAccordion] = useState<AccordionEventKey | null>(null);

    const toggleAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
        setActiveAccordion(eventKey === activeAccordion ? null : eventKey);
    };

    const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
    const [email, setEmail] = useState<string | null>(null);
    const [address, setAddress] = useState<string | null>(null);
    const [gender, setGender] = useState<number | null>(null);
    const [groupId, setGroupId] = useState<number | null>(null);

    useEffect(() => {
        
        setPhoneNumber(userData?.mobilePhones??'')
        setEmail(userData?.email??'')
        setAddress(userData?.address??'')
        setGender(userData?.gender??8000)
        setGroupId(userData?.groupId??6)
    }, [userData])

    const handleUpdate = async () => {
        // Form verilerini güncellemek için gerekli işlemleri burada gerçekleştirin
        // console.log("Form verileri:", userData);
        
        if (!userData || userData === null || userData?.userId === null) {        
            alert("Kullanıcı bilgileri kaydedilirken bir hata oluştu.")
            return;
        }

        if (groupId && (groupId === 1 || groupId === 2) && !email) {
            alert("TÜBSİS veya POLSİS kullanıcılarının e-posta bilgisi bulunmalıdır.")
            return;
        }

        if (!isValidPhoneNumber) {
            return;
        }

        var updateRequest = {
            userId: userData?.userId,
            email: email??'',
            mobilePhones: phoneNumber??'',
            gender: gender??8000,
            groupId: groupId??6,
            address: address??''
        }
        // console.log("Yeni veriler:", updateRequest);

        var response = await updateUserInfo(updateRequest);

        if (response.success) {
            alert(response.message)
            // window.location.reload()   
        } else {
            alert("Kullanıcı bilgileri kaydedilirken bir hata oluştu:" + response.message)
        }
    };

    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState<boolean>(true);
    
    const handleItemChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'email') {
            setEmail(value);
        } else if (name === 'phoneNumber') {
            setPhoneNumber(value);
            const pattern = /^\d{10,20}$/;
            setIsValidPhoneNumber(pattern.test(value));
        } else if (name === 'group') {
            setGroupId(parseInt(value));
        } else if (name === 'gender') {
            setGender(parseInt(value));
        } else if (name === 'address') {
            setAddress(value);
        } 
    };

    return (
        <Accordion activeKey={activeAccordion} onSelect={toggleAccordion}>
            <Card key={1}>
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <Button className='d-flex justify-content-between align-items-center w-100' variant='link' onClick={(e) => toggleAccordion("index.toString()", e)}>
                            <div className='text-left text-gray-700'>
                                KULLANICI BİLGİLERİ
                            </div>
                        </Button>
                    </div>
                </Card.Header>
                <Accordion.Collapse eventKey={"index.toString()"}>
                    <Card.Body>
                        <Form onSubmit={handleUpdate}>
                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId='email' label="Eposta">
                                        <FormControl
                                            type="email"
                                            name="email"
                                            defaultValue={userData?.email}
                                            onChange={handleItemChange} />
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId='phoneNumber' label="Telefon Numarası">
                                        <FormControl
                                            type="tel"
                                            name="phoneNumber"
                                            inputMode="numeric"
                                            value={phoneNumber??''}
                                            isInvalid={!isValidPhoneNumber}
                                            onChange={handleItemChange} />
                                        <Form.Control.Feedback type="invalid">
                                            Geçerli bir telefon numarası girin.
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId='group' label="Program">
                                        <Form.Select
                                            name="group"
                                            value={groupId??6}
                                            onChange={handleItemChange}>
                                            <option value='1'>TÜBSİS</option>
                                            <option value='2'>POLSİS</option>
                                            <option value='6'>SBP</option>
                                        </Form.Select>
                                    </FloatingLabel>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId='gender' label="Cinsiyet">
                                        <Form.Select
                                            name="gender"
                                            value={gender??8000}
                                            onChange={handleItemChange}>
                                            <option value='8000'>Seçiniz</option>
                                            <option value='8001'>Kadın</option>
                                            <option value='8002'>Erkek</option>
                                        </Form.Select>
                                    </FloatingLabel>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <FloatingLabel controlId='address' label="Adres">
                                        <FormControl
                                            type="textarea"
                                            as="textarea"
                                            rows={1}
                                            name="address"
                                            value={address??''}
                                            onChange={handleItemChange}/>
                                    </FloatingLabel>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <Button variant="primary" onClick={handleUpdate}>
                                        Kaydet
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )

}

export default (PatientUserInfo)